import _asyncToGenerator from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/regenerator/index.js";
import { loadAbsorbersPlugin } from "tsparticles-plugin-absorbers";
import { loadDestroyUpdater } from "tsparticles-updater-destroy";
import { loadEmittersPlugin } from "tsparticles-plugin-emitters";
import { loadExternalTrailInteraction } from "tsparticles-interaction-external-trail";
import { loadPolygonMaskPlugin } from "tsparticles-plugin-polygon-mask";
import { loadRollUpdater } from "tsparticles-updater-roll";
import { loadSlim } from "tsparticles-slim";
import { loadTiltUpdater } from "tsparticles-updater-tilt";
import { loadTwinkleUpdater } from "tsparticles-updater-twinkle";
import { loadWobbleUpdater } from "tsparticles-updater-wobble";
export function loadFull(_x) {
  return _loadFull.apply(this, arguments);
}

function _loadFull() {
  _loadFull = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadSlim(engine);

          case 2:
            _context.next = 4;
            return loadDestroyUpdater(engine);

          case 4:
            _context.next = 6;
            return loadRollUpdater(engine);

          case 6:
            _context.next = 8;
            return loadTiltUpdater(engine);

          case 8:
            _context.next = 10;
            return loadTwinkleUpdater(engine);

          case 10:
            _context.next = 12;
            return loadWobbleUpdater(engine);

          case 12:
            _context.next = 14;
            return loadExternalTrailInteraction(engine);

          case 14:
            _context.next = 16;
            return loadAbsorbersPlugin(engine);

          case 16:
            _context.next = 18;
            return loadEmittersPlugin(engine);

          case 18:
            _context.next = 20;
            return loadPolygonMaskPlugin(engine);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadFull.apply(this, arguments);
}